import PubSub from "pubsub-js";

import { CART_ITEM_ADDED, CART_ITEMS_ADDED } from "../constants";
import {
  addCartItem,
  clearCart,
  setCart,
  deleteCartItem,
  editCartItem,
  getCart,
} from "../reducers/cart";
import { storeCartInBackend } from "../apiCalls";
import { CheckoutStorageService } from "./CheckoutService";
import { cartLocalStorageService as cartLSService } from "./CartLocalStorageService";
import { isProductDataWithOptions } from "../utils";

export class CartService {
  constructor(store, cartLocalStorageService = cartLSService) {
    this.store = store;
    this.cartLocalStorageService = cartLocalStorageService;
  }

  updateCartByTime() {
    const lastUpdate = this.cartLocalStorageService.getCartLastUpdate();
    const cartData = this.store.getState().cart.filter((item) => item.qty > 0);
    if (lastUpdate && cartData.length) {
      if (
        Date.now() - lastUpdate >
        86400000 // 24h
      ) {
        this.fetchCart(this.cartLocalStorageService.cartUUID);
      }
    }
  }

  saveCart = async ({ cart, callback, emptyCart } = {}) => {
    try {
      let cartData =
        cart || this.store.getState().cart.filter((item) => item.qty > 0);
      const response = await storeCartInBackend(null, cartData, emptyCart);

      this.cartLocalStorageService.setCartLastUpdate(Date.now());

      if (response.cart_data) {
        CheckoutStorageService.prefillFirstStepData(response.cart_data);
      }
      callback?.(response);

      cartData = this.store.getState().cart.filter((item) => item.qty > 0);
      this.cartLocalStorageService.setCart(cartData);
    } catch (error) {
      console.error(error);
      callback?.(null, error);
    }
  };

  addItemToCart(productData) {
    this.store.dispatch(addCartItem(productData));
    const basketQtySync = this.store.getState().settings.basketQtySync;

    if (!basketQtySync) {
      PubSub.publish(CART_ITEM_ADDED, productData);
    }
  }

  addItemsToCart(updatedProducts) {
    const basketQtySync = this.store.getState().settings.basketQtySync;

    const newItems = [];
    const existedItems = [];
    updatedProducts.forEach((element) => {
      if (!isProductDataWithOptions(element.item)) {
        const item = this.store
          .getState()
          .cart.find((item) => item.id === element.id);
        if (!item) {
          newItems.push(element);
        } else {
          existedItems.push(element);
        }
      } else {
        newItems.push(element);
      }
    });
    if (newItems.length) {
      this.store.dispatch(addCartItem(newItems));
    }
    if (existedItems.length) {
      this.store.dispatch(editCartItem(existedItems));
    }

    if (!basketQtySync) {
      PubSub.publish(CART_ITEMS_ADDED, updatedProducts);
    }
  }

  setCart(cartValue) {
    this.store.dispatch(setCart(cartValue));
  }

  clearCart() {
    this.store.dispatch(clearCart());
    this.saveCart({ emptyCart: true });
  }

  deleteCart(){
    this.store.dispatch(clearCart());
    this.cartLocalStorageService.deleteCart();
  }

  deleteCartItem(id) {
    this.store.dispatch(deleteCartItem(id));
    // save to backend and storage
    this.saveCart();
  }

  editCartItem(updatedData, save = true) {
    this.store.dispatch(editCartItem(updatedData));
    // save to backend and storage
    if (save) {
      this.saveCart();
    }
  }

  async fetchCart(cartId) {
    const data = await this.store.dispatch(getCart(cartId)).unwrap();
    this.cartLocalStorageService.setCart(data.lines);
  }
}
